"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import AnnouncementBar from "@/components/layout/announcement-bar";
import { CartProvider } from "@/contexts/cart-context";
import { CartDrawer } from "@/components/cart/cart-drawer";
import { AuthProvider } from "@/contexts/auth-context";
import KwikPass from "@/components/KwikPass";
import Header from "@/components/layout/header";
import Footer from "@/components/layout/footer";
import AffiliateTracker from "@/AffiliateTracker";
import {TrackingInitializer} from "@/components/tracking-initializer";
import { publishEvent, EventType, IPageViewEvent} from "@/events";

export default function ClientBody({
  children,
}: {
  children: React.ReactNode;
}) {

  const pathname = usePathname();

  const sendPageView = (url: string) => {
    const event: IPageViewEvent = {
      type: EventType.PAGE_VIEW,
      path: url,
      title: document.title,
      timestamp: Date.now(),
    };

    if (typeof window !== 'undefined') {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'PageView');
      }
    
      // Fire GA
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: url,
          page_title: document.title,
        });
      }
  
      publishEvent(event);
    }
  }
  
  // Remove any extension-added classes during hydration
  useEffect(() => {
    // This runs only on the client after hydration
    document.body.className = "antialiased";
  }, [])

  useEffect(() => {
    setTimeout(() => {
      // HACK: Delay to ensure the page is fully loaded after that will fire the script
      sendPageView(pathname);
    }, 2000);
  }, [pathname]);

  return (
    <AuthProvider>
      <CartProvider>
        <div className="antialiased">
          <AnnouncementBar />
          <Header />
          {children}
          <AffiliateTracker />
          <TrackingInitializer />
          <KwikPass />
          <CartDrawer />
          <Footer />
        </div>
      </CartProvider>
    </AuthProvider>
  );
}
